const API_BASE = import.meta.env.VITE_API_URL || 'https://api.cellysheets.ca/api';

const handleResponse = async (response: Response) => {
  if (response.status === 401) {
    window.dispatchEvent(new Event('auth:unauthorized'));
  }
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'API Request Failed');
  }
  return response.json();
};

export const feedbackService = {
  async submit(token: string | null, type: string, message: string) {
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(`${API_BASE}/feedback`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ type, message }),
    });

    return handleResponse(response);
  }
};